var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNewDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "16px",
    viewBox: "0 0 34 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_newDetails") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "**DASHBOARD**",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dashboard-expand",
    transform: "translate(-1200.000000, -529.000000)",
    fill: "#05315F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "ic_newDetails",
    points: "1226.03684 545 1224.11316 543.11236 1228.85526 538.348315 1200 538.348315 1200 535.651685 1228.9 535.651685 1224.15789 530.88764 1226.03684 529 1234 537"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNewDetails);
export default __webpack_public_path__ + "static/media/ic_newDetails.ad93c7e66760c268fd5ffb1d1032feba.svg";
export { ForwardRef as ReactComponent };